<div class="m-subheader">
  <div class="mr-auto">
    <h3 class="m-subheader__title">
      {{ 'sales.statistics.city' | transloco }}
    </h3>
    <span></span>
    <hx-date-range-select [onlyPastDates]="true" class="date-align" [(ngModel)]="params.date" (selectChange)="applyFilters()"></hx-date-range-select>
  </div>
</div>

<div class="m-content">
  <!--Begin::Main Portlet-->
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="m_datatable m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30">
            <table class="m-datatable__table" *ngIf="sales.length && !isloading.sales">
              <thead class="m-datatable__head">
              <tr class="m-datatable__row m-datatable__row--head">
                <th class="m-datatable__cell">
                  <span>#</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.city-title' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.paid-total' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.profit-total' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.receipt-count' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.average-receipt' | transloco }}</span>
                </th>
              </tr>
              </thead>
              <tbody class="m-datatable__body">
              <tr *ngFor="let even = even; let i = index; let item of sales"
                  class="m-datatable__row" [ngClass]="{ 'm-datatable__row--even': even }">
                <td class="m-datatable__cell">
                  {{ i + counter }}
                </td>

                <td class="m-datatable__cell">
                  <a *ngIf="item.cityTitle" [title]="item.cityTitle | uiLabel" [routerLink]="['../sales/city']" [queryParams]="{dateFrom: params.date?.from, dateTo: params.date?.to, cityId: item.cityId, allCityIds: allCityIds.join(',') }">
                    {{ item.cityTitle | uiLabel }}
                  </a>
                </td>

                <td class="m-datatable__cell">
                  {{ item.total | moneyFormat }}
                </td>

                <td class="m-datatable__cell">
                  {{ item.total - item.totalCostPrice | moneyFormat }}
                </td>

                <td class="m-datatable__cell">
                  {{ item.orderCount }}
                </td>

                <td class="m-datatable__cell">
                  {{ item.averageReceipt | moneyFormat }}
                </td>

              </tr>
              </tbody>
            </table>

            <hx-loader [length]="sales.length" [isLoading]="isloading.sales"></hx-loader>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--End::Main Portlet-->
</div>
